export default {
      id: "hide-usage",
      viewBox: "0 0 19 14",
      url: __webpack_public_path__ + "icons-sprite.03ac376.svg#hide-usage",
      toString: function () {
        return this.url;
      }
    }